import api, { fetchCsrfCookie, unwrap } from './client'
import type { ForgotPasswordPayload, LoginPayload, ResetPasswordPayload, User } from '@/types/models'

export const authApi = {
  async login(payload: LoginPayload): Promise<User> {
    await fetchCsrfCookie()
    return unwrap(api.post<{ data: User }>('/auth/login', payload))
  },

  logout(): Promise<unknown> {
    return api.post('/auth/logout')
  },

  user(): Promise<User> {
    return unwrap(api.get<{ data: User }>('/auth/user'))
  },

  async forgotPassword(payload: ForgotPasswordPayload): Promise<unknown> {
    await fetchCsrfCookie()
    return api.post('/auth/forgot-password', payload)
  },

  async resetPassword(payload: ResetPasswordPayload): Promise<unknown> {
    await fetchCsrfCookie()
    return api.post('/auth/reset-password', payload)
  },
}
